import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cancel-holiday-modal',
  templateUrl: './cancel-holiday-modal.component.html',
  styleUrls: ['./cancel-holiday-modal.component.css'],
})
export class CancelHolidayModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}
  @Input() data: any;

  ngOnInit(): void {}

  closeClicked() {
    this.activeModal.close('close');
  }

  confirmClicked() {
    this.activeModal.close('confirm');
  }
}
